import { types } from 'mobx-state-tree';
import orderStatusTranslation from 'js/config/orderStatusTranslation';

export default types
  .model('OrderSummary', {
    title: types.string,
    buyer: types.maybeNull(types.string),
    seller: types.maybeNull(types.string),
    image: types.maybeNull(types.string),
    uid: types.string,
    pickup: types.string,
    dropoff: types.string,
    updated_at: types.string,
    status: types.string,
    price: types.number,
  })
  .views(self => ({
    get human_status() {
      return orderStatusTranslation[self.status] || `Unknown status (${self.status})`;
    },
  }));
